// src/hooks/useTracks.js
import { isIOS, isMobileSafari, isSafari } from "react-device-detect";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getPlaylistOrder } from "../Util/helpers";

export const GetTrackByFilteredCategory = () => {

    const playingTracks = useSelector((state) => state.player.playingTracks);
    const config = useSelector((state) => state.player.config);
    const isAudio = ["relaxation", "articles", "stories"];
    const isMusic = 164;


    if (!playingTracks) return { audio: null, music: null, sounds: [], my_mix: [], playlist: [] };

    if (config?.type == "mix") return { audio: null, music: null, sounds: [], my_mix: playingTracks, playlist: [] };

    if (config?.type == "playlist") return { audio: null, music: null, sounds: [], my_mix: [], playlist: playingTracks };

    // Extract audio
    const audio = playingTracks.find(t => isAudio.includes(t.type)) || {};

    //  Extract music
    const music = playingTracks.find(t => t.soundcategory == isMusic) || {};

    // Extract sounds
    const sounds = playingTracks.filter(t => !isAudio.includes(t.type) && t.soundcategory !== isMusic);

    return {
        music,
        audio,
        sounds,
        my_mix: [],
        playlist: []
    };
};

const getMediaUrl = (obj) => {
    if (obj['type'] !== "sounds") return obj['audio'];
    // if (obj['audio_mobile']) return obj['audio_mobile'];
    if (isMobileSafari || isSafari || isIOS) return obj['audio_mobile'] ? obj['audio_mobile'] : obj['ios_sound'];
    return obj['audio'];
}

export const GetPlayingTracks = () => {
    const playingTracks = useSelector((state) => state.player.playingTracks);
    const config = useSelector((state) => state.player.config);

    // console.log(playingTracks)
    const modifiedTracks = [];
    playingTracks?.forEach((item) => {
        modifiedTracks.push({
            id: item.id,
            url: getMediaUrl(item),
            volume: 1,
            playing: false,
            loop: config?.type == "playlist" ? config?.playlist_type == "article_stories_relaxation" ? config.shouldPlay === item.id : item.type == 'sounds' && item?.soundcategory !== 163 && item?.soundcategory !== 164 : item.type == 'sounds',
            type: item?.type,
            category: item?.soundcategory,
        });
    });
    return modifiedTracks || [];
};

export const GetAllTracks = () => {
    const playingTracks = useSelector((state) => state.player.playingTracks);
    return playingTracks || [];
};


export const GetMixerConfig = () => {
    const MUSIC_CATEGORY_ID = 164;
    const { t, i18n } = useTranslation();

    const data = useSelector((state) => state.player.playingTracks);
    const config = useSelector((state) => state.player.config);

    const getNameByType = (type) => {
        const AUDIO_TYPES = ["relaxation", "articles", "stories"];
        if (AUDIO_TYPES.includes(type)) return type;
        return 'sounds & music';
    }

    const getDuration = (data) => {
        let total = 0;

        data.forEach(item => {
            const dur = parseFloat(item.duration);
            if (!isNaN(dur)) total += dur;
        });

        return Math.round(total);
    };

    const categories = {
        playlist: {
            name: '',
            data: []
        },
        mix: {
            name: '',
            data: []
        },
        relaxation: {
            name: '',
            data: []
        },
        articles: {
            name: '',
            data: []
        },
        stories: {
            name: '',
            data: []
        },
        sounds: {
            name: '',
            data: []
        },
    };

    if (config['type'] === 'mix') {
        categories['mix']['name'] = t("playlists.myMix");
        categories['mix']['data'] = data;
        return categories;
    }

    if (config['type'] === 'playlist') {
        categories['playlist']['name'] = config['isPlaylistMix'] ? t("playlists.myPlaylistMix") : t("playlists.myPlaylists");
        categories['playlist']['data'] = data;
        categories['playlist']['duration'] = getDuration(data);
        return categories;
    }

    data.forEach(item => {
        if (categories[item.type]) {
            categories[item.type]['name'] = getNameByType(item.type);
            categories[item.type]['data'].push(item);
            return;
        }
    });

    return categories;
};
